// Section 24.12 in the menu: save to a named slot, load a slot or an earlier autosave (not in
// ironman), export the save or the shareable run, import a file. An overlay root: it reads the
// store and calls store actions.
import { useState } from 'preact/hooks';
import {
  closeOverlay,
  currentRunId,
  deleteSlot,
  exportRun,
  game,
  importRun,
  loadAutosave,
  loadSlot,
  saves,
  saveToSlot,
  ui,
} from '../../store';
import { savesVM } from '../../viewModels';
import { uiText } from '../text/en';
import { downloadFile } from './download';
import { SaveList } from './save-list';

export function SavesPanel() {
  const vm = savesVM(saves.value, game.value, currentRunId());
  const mode = ui.value.savesMode;
  const [name, setName] = useState('');
  const t = uiText.saves;
  const exportFile = (shareable: boolean): void => {
    const file = exportRun({ shareable });
    if (file !== undefined) downloadFile(file);
  };
  return (
    <div class="saves">
      <header class="overlay__head">
        <h2 id="saves-title">{t.title}</h2>
        <button type="button" class="button button--small" onClick={() => closeOverlay()}>
          {t.close}
        </button>
      </header>
      {vm.inGame && (
        <section class="saves__section" aria-labelledby="saves-save">
          <h3 id="saves-save">{t.save}</h3>
          {vm.canSaveSlot ? (
            <form
              class="saves__form"
              onSubmit={(e) => {
                e.preventDefault();
                if (saveToSlot(name) === true) setName('');
              }}
            >
              <label class="field">
                <span class="field__label">{t.saveName}</span>
                <input
                  type="text"
                  value={name}
                  maxLength={40}
                  onInput={(e) => setName(e.currentTarget.value)}
                  {...(mode === 'save' ? { 'data-autofocus': true } : {})}
                />
              </label>
              <button type="submit" class="button">
                {t.saveButton}
              </button>
            </form>
          ) : (
            <p class="hint">{t.ironman}</p>
          )}
        </section>
      )}
      <section class="saves__section" aria-labelledby="saves-slots">
        <h3 id="saves-slots">{t.slots}</h3>
        <SaveList
          rows={vm.slots}
          caption={t.slots}
          empty={t.noSlots}
          onLoad={(r) => loadSlot(r.id)}
          onDelete={(r) => deleteSlot(r.id)}
        />
      </section>
      <section class="saves__section" aria-labelledby="saves-auto">
        <h3 id="saves-auto">{t.autosaves}</h3>
        <SaveList
          rows={vm.start === null ? vm.autosaves : [...vm.autosaves, vm.start]}
          caption={t.autosaves}
          empty={t.noAutosaves}
          onLoad={(r) => loadAutosave(r.id)}
        />
      </section>
      <section class="saves__section" aria-labelledby="saves-files">
        <h3 id="saves-files">{t.export}</h3>
        <div class="card__actions">
          {vm.inGame && (
            <>
              <button type="button" class="button" onClick={() => exportFile(false)}>
                {t.exportSave}
              </button>
              <button type="button" class="button" onClick={() => exportFile(true)}>
                {t.exportRun}
              </button>
            </>
          )}
          <label class="button file-button">
            {t.import}
            <input
              type="file"
              accept=".json,application/json"
              class="visually-hidden"
              onChange={(e) => {
                const file = e.currentTarget.files?.[0];
                e.currentTarget.value = '';
                if (file !== undefined) void importRun(file);
              }}
            />
          </label>
        </div>
      </section>
    </div>
  );
}
